class CartRemove extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const index = this.closest('cart-item').getAttribute('data-item-index');
      const handle = this.closest('cart-item').getAttribute('data-item-handle');
      this.closest('cart-item').updateCart(index, 0,handle);
    });
  }
}

customElements.define('remove-item', CartRemove);
class Cart extends HTMLElement{
  constructor() {
    super();
    const input = this.querySelector('.js-quantity-input');
    this.debouncedOnChange = debounce((element) => {
      let line= element.closest('cart-item').getAttribute('data-item-index');
      let quantity = element.value;
      this.updateCart(line,quantity);
    }, 300);
    let _this = this
    if(input){
      input.addEventListener('countChange', function (){
        _this.debouncedOnChange(this)
      });
    }
  }

  updateCart(line,quantity,handle) {
    $('#cart-form').addClass('loading');
    const body = JSON.stringify({
      line: line,
      quantity: quantity
    });
    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const statejson =JSON.parse(state)
          updateCartPopup();
          if(handle != undefined){
            $(`.product-${handle}`).removeClass('selected');
            $(`.product-${handle}`).find('button').removeAttr('disabled');
          }
          if(statejson.item_count < parseInt(quantity,10)){
            let errorMessage = window.cartStrings.quantityError.replace(
                '[quantity]',
                statejson.item_count
            );
            alert( errorMessage)
          }
        }) .catch((e) => {
        console.error(e);
    });
  }
  errorMessage(resp){
    alert(resp.description)
  }
}
customElements.define('cart-item', Cart )
